<!--
 * @Descripttion:
 * @version:
 * @Author: etong
 * @Date: 2020-10-13 11:39:13
 * @LastEditors: WangQi
 * @LastEditTime: 2022-06-08 17:58:23
-->
<template>
  <div class="common_table-container">
    <!-- 此处需要boolean -->
    <!-- :row-key="rowKey" -->
    <!-- keep-source -->

    <ux-grid
      v-loading="listLoading"
      ref="table"
      :key="tableKey"
      :data="list"
      :show-summary="isShowSummary || isShowSummaryRow"
      :summary-method="summaryMethod || getSummary"
      :cell-class-name="cellClassName"
      :class="tableClassName"
      :header-cell-class-name="headerCellClassName"
      :height="newHeight"
      show-overflow
      use-virtual
      stripe
      border
      fit
      highlight-current-row
      style="width: 100%;"
      @cell-mouse-enter="cellMouseEnter"
      @cell-mouse-leave="cellMouseLeave"
      @row-contextmenu="openMenu"
      @row-click="openMenu"
      @header-contextmenu="openHeaderMenu"
      @header-dragend="handleDragent"
      @select-all="handleSelectionChangeAll"
      @selection-change="handleSelectionChange"
      @doLayout="doLayout">
      <ux-table-column
        v-if="selection"
        :selectable="selectStatusInit"
        :reserve-selection="rowKey?true:false"
        :width="(isShowSummary || isShowSummaryRow) ? 50 : 40"
        type="checkbox"
      />
      <ux-table-column
        v-if="isShowIndex"
        type="index"
        width="40"/>
      <!-- <ux-table-column key="1111111111" field="cesjo" title="cesjo" width="140">
        <template slot-scope="{column}" slot="header">
          <span>{{ column.title }}</span>
        </template>
        <template slot-scope="scope">
          <div>
            <span>123</span>
          </div>
        </template>
      </ux-table-column> -->
      <template v-for="(item, index) in fieldList">
        <ux-table-column
          v-if="!noShowColumnArr.includes(item.field_code) && item.is_show > 0"
          :fixed="item.freeze_type == '' ? '' : item.freeze_type"
          :title="item.field_name"
          :key="index"
          :sortable="item.is_sort> 0"
          :show-overflow-tooltip="item.show_tooltip > 0"
          :field="item.field_code"
          :prop="item.field_code"
          :align="item.text_align"
          :min-width="item.field_width ? item.field_width : ''"
        >
          <template slot-scope="{column}" slot="header">
            <!-- [item.field_code] -->
            <el-popover v-trim v-if="item.field_input_type&&isEditTypeTable&&item.field_code==='adjustment_reason'" v-model="visiblePopover[item.field_code]" placement="top" width="300" trigger="click">
              <div>
                <p class="bold fz-l">批量修改{{ column.title }}</p>
                <el-form :ref="'batchEdit_'+item.field_code" :model="batchEdit[item.field_code+'_obj']" label-width="0px" class="rateData">
                  <!-- <el-form-item :rules="[{ required: true, message: '请填写折扣', trigger: 'blur' }]" label="" prop="discount"> -->
                  <jj-form-item
                    :key="item.field_code"
                    :item="typeToObject(item.field_value_type || 'input', batchEdit[item.field_code+'_obj'], item)"
                    v-bind="typeToObject(item.field_value_type || 'input', batchEdit[item.field_code+'_obj'], item)"
                    @input="handleBatchInput($event, item.field_code, batchEdit[item.field_code+'_obj'])"
                  />
                </el-form>
                <div slot="footer" class="text-right">
                  <el-button @click="closePopover(item.field_code)">取消</el-button>
                  <el-button type="primary" @click="batchEditSave(`batchEdit_${item.field_code}`,item.field_code)">确定</el-button>
                </div>
              </div>
              <div slot="reference" class="cp">
                <span v-if="isEditTypeTable" class="addcolor">*</span>
                <span>{{ column.title }} </span>
                <i v-if="isEditTypeTable" class="el-icon-edit"></i>
              </div>
            </el-popover>
            <el-tooltip
              v-else-if="item.memo"
              :content="content(item.memo)"
              class="item"
              effect="dark"
              placement="top-start"
            >
              <span>
                <span>{{ column.title }}</span>
                <i class="el-icon-info" ></i>
              </span>
            </el-tooltip>
            <span v-else>{{ column.title }}</span>
          </template>
          <template slot-scope="scope">
            <template v-if="!isForm || !isEditTypeTable || !item.field_input_type">
              <!-- 前后端请根据实际情况手动配置 -->
              <!-- 需要特殊处理的行 -->
              <template v-if="item.is_slot > 0">
                <!-- 具名插槽 当isSlot为1 需要特殊 处理 name 为field_code -->
                <!--
                eg: 1. 效期 后端返回 开始时间字段 和 结束时间字段
                    2. 需要特殊展示的单号 活动对象等
                    3. 点击事件
                    4. 超链接
                    5. 状态等tag
                    6. 预留 (图片)
                -->
                <slot :name="item.field_code" :row="scope.row" :index="scope.$rowIndex" ></slot>
              </template>
              <template v-else>
                <!-- 查看详情的时候 当前字段不可编辑时执行这里 -->
                <span v-if="item.field_input_type" :key="item.field_code+'_'+scope.$rowIndex">
                  {{
                    convertString(scope.row, item)
                  }}
                </span>
                <!-- 正常的整数 负数 string -->
                <span v-else-if="!item.field_type || item.field_type === 'string'" :key="item.field_code+'_'+scope.$rowIndex">
                  {{
                    scope.row[item.field_code]
                  }}
                </span>
                <!-- 两位小数的 金额 -->
                <span v-else-if="item.field_type === 'number'" :key="item.field_code+'_'+scope.$rowIndex">
                  {{
                    amountFormat(scope.row[item.field_code])
                  }}
                </span>
                <!-- 数字(千分符) int -->
                <span v-else-if="item.field_type === 'int'" :key="item.field_code+'_'+scope.$rowIndex">
                  {{
                    number_format(scope.row[item.field_code],0)
                  }}
                </span>
                <!-- 数字(千分符) int(6位) -->
                <span v-else-if="item.field_type === 'int6'" :key="item.field_code+'_'+scope.$rowIndex">
                  {{
                    number_format(scope.row[item.field_code],6)
                  }}
                </span>
                <!-- 时间(年月日)格式处理 -->
                <span v-else-if="item.field_type === 'datetime'" :key="item.field_code+'_'+scope.$rowIndex">
                  {{
                    parseTime(scope.row[item.field_code],"{y}-{m}-{d}")
                  }}
                </span>
                <!-- 时间格式处理 -->
                <span v-else-if="item.field_type === 'time'" :key="item.field_code+'_'+scope.$rowIndex">
                  {{
                    parseTime(scope.row[item.field_code])
                  }}
                </span>
                <!-- 百分比格式处理 -->
                <span
                  v-else-if="item.field_type === 'percent'"
                  :key="item.field_code"
                >
                  {{ scope.row[item.field_code] * 100 }}%
                </span>
                <!-- 内外部链接 -->
                <el-link
                  v-else-if="/erLink/.test(item.field_type)&&scope.row[item.field_code]"
                  :href="renderLink(scope.row[item.field_code], item, scope.row)"
                  :target="item.field_type === 'outerLink'?'_blank':''"
                  :key="item.field_code+'_'+scope.$rowIndex"
                  type="primary"
                  style="line-height:16px;vertical-align: baseline;">
                  {{ convertStringToObj(item['memo'])['linkLabel'] || scope.row[item.field_code] }}
                </el-link>
                <el-image
                  v-else-if="item.field_type==='pic'&&scope.row[item.field_code]"
                  :key="item.field_code+'_'+scope.$rowIndex"
                  :src="scope.row[item.field_code]?BASE_CDN_API+scope.row[item.field_code]:''"
                  :alt="scope.row[item.field_code]||''"
                  fit="scale-down"
                />
                <tag
                  v-else-if="item.field_type==='statusTag'&&scope.row[item.field_code]"
                  :key="item.field_code+'_'+scope.$rowIndex"
                  :scene="scope.row[convertStringToObj(item['memo'])['tagStyle']]"
                >
                  {{ scope.row[convertStringToObj(item['memo'])['tagName']] }}
                </tag>
                <span v-else :key="item.field_code+'_'+scope.$rowIndex">{{ scope.row[item.field_code] }}</span>
              </template>
            </template>
            <template v-else slot-scope="scope">
              <template v-if="!item.field_input_type">
                <!-- 前后端请根据实际情况手动配置 -->
                <!-- 需要特殊处理的行 -->
                <template v-if="item.is_slot > 0">
                  <!-- 具名插槽 当isSlot为1 需要特殊 处理 name 为field_code -->
                  <!--
                eg: 1. 效期 后端返回 开始时间字段 和 结束时间字段
                    2. 需要特殊展示的单号 活动对象等
                    3. 点击事件
                    4. 超链接
                    5. 状态等tag
                    6. 预留 (图片)
                -->
                  <slot :name="item.field_code" :row="scope.row" :index="scope.$rowIndex" ></slot>
                </template>
                <template v-else>
                  <!-- 正常的整数 负数 string -->
                  <span v-if="!item.field_type || item.field_type === 'string'" :key="item.field_code+'_'+scope.$rowIndex">
                    {{
                      scope.row[item.field_code]
                    }}
                  </span>
                  <!-- 两位小数的 金额 -->
                  <span v-else-if="item.field_type === 'number'" :key="item.field_code+'_'+scope.$rowIndex">
                    {{
                      amountFormat(scope.row[item.field_code])
                    }}
                  </span>
                  <!-- 数字(千分符) int -->
                  <span v-else-if="item.field_type === 'int'" :key="item.field_code+'_'+scope.$rowIndex">
                    {{
                      number_format(scope.row[item.field_code],0)
                    }}
                  </span>
                  <!-- 数字(千分符) int(6位) -->
                  <span v-else-if="item.field_type === 'int6'" :key="item.field_code+'_'+scope.$rowIndex">
                    {{
                      number_format(scope.row[item.field_code],6)
                    }}
                  </span>
                  <!-- 时间(年月日)格式处理 -->
                  <span v-else-if="item.field_type === 'datetime'" :key="item.field_code+'_'+scope.$rowIndex">
                    {{
                      parseTime(scope.row[item.field_code],"{y}-{m}-{d}")
                    }}
                  </span>
                  <!-- 时间格式处理 -->
                  <span v-else-if="item.field_type === 'time'" :key="item.field_code+'_'+scope.$rowIndex">
                    {{
                      parseTime(scope.row[item.field_code])
                    }}
                  </span>
                  <!-- 百分比格式处理 -->
                  <span
                    v-else-if="item.field_type === 'percent'"
                    :key="item.field_code+'_'+scope.$rowIndex"
                  >
                    {{ scope.row[item.field_code] * 100 }}%
                  </span>
                  <el-link
                    v-else-if="/erLink/.test(item.field_type)&&scope.row[item.field_code]"
                    :key="item.field_code+'_'+scope.$rowIndex"
                    :href="renderLink(scope.row[item.field_code], item, scope.row)"
                    :target="item.field_type === 'outerLink'?'_blank':''"
                    type="primary"
                    style="line-height:16px;vertical-align: baseline;">
                    {{ convertStringToObj(item['memo'])['linkLabel'] || scope.row[item.field_code] }}
                  </el-link>
                  <el-image
                    v-else-if="item.field_type==='pic'&&scope.row[item.field_code]"
                    :key="item.field_code+'_'+scope.$rowIndex"
                    :src="scope.row[item.field_code]?BASE_CDN_API+scope.row[item.field_code]:''"
                    :alt="scope.row[item.field_code]||''"
                    fit="scale-down"
                  />
                  <tag
                    v-else-if="item.field_type==='statusTag'&&scope.row[item.field_code]"
                    :key="item.field_code+'_'+scope.$rowIndex"
                    :scene="scope.row[convertStringToObj(item['memo'])['tagStyle']]"
                  >
                    {{ scope.row[convertStringToObj(item['memo'])['tagName']] }}
                  </tag>
                  <span v-else :key="item.field_code+'_'+scope.$rowIndex">{{ scope.row[item.field_code] }}</span>
                </template>
              </template>
              <template v-else slot-scope="scope">
                <jj-form-item
                  :item-ref="item.field_code+'_'+scope.$rowIndex"
                  :key="item.field_code+'_'+scope.$rowIndex"
                  :item="typeToObject(item.field_value_type || 'input', scope.row, item)"
                  v-bind="typeToObject(item.field_value_type || 'input', scope.row, item)"
                  :value="scope.row[item.field_code]"
                  @change="handleLinkChange($event, item, scope.row,scope)"
                  @input="handleInput($event, item.field_code, scope.row)"
                />
              </template>
            </template>
          </template>
        </ux-table-column>
      </template>
    </ux-grid>
    <HeaderContextmenu
      ref="headerMenu"
      :method="fieldFnMethod"
      :offset-x="offsetX"
      :offset-y="offsetY"
      @refresh="getList"
    />
    <pagination
      v-show="total > 0&&isShowDetailPager"
      :total="total"
      :page.sync="listQuery.page_no"
      :limit.sync="listQuery.page_size"
      @pagination="getList"
    />
  </div>
</template>

<script>
import {
  amountFormat,
  number_format,
  parseTime,
  deepClone,
  optionsChain,
  commonSumMethod
} from '@/utils/index'
import HeaderContextmenu from '@/components/HeaderContextmenu'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import {
  EexcuteDataSource
} from '@/api/system'
import { handleLinkChangeEvent } from '@/utils/formChangeEvent.js'
import { GetUserListField } from '@/api/erpCommon'

export default {
  name: 'JJuxCommonTable',
  inject: ['lowcodeFormInstance'],
  components: { HeaderContextmenu, Pagination },
  props: {
    list: {
      type: Array
    },
    fieldConf: {
      type: Object,
      default: () => {}
    },
    tableKey: {
      type: [Number, String],
      default: 0
    },
    // 不显示该列数据 field_code
    noShowColumnArr: {
      type: Array,
      default: () => []
    },
    listLoading: {
      type: Boolean
    },
    selection: {
      // 是否显示复选框
      type: Boolean
    },
    isShowDetailPager: {
      // 是否显示分页器
      type: Boolean,
      default: false
    },
    isShowIndex: {
      // 是否显示复选框
      type: Boolean,
      default: false
    },
    rowKey: {
      // 回显的筛选字段
      type: String
    },
    cellClassName: {
      type: [Function, String]
    },
    selectInit: {
      type: Function
    },
    summaryMethod: {
      type: Function
    },
    total: {
      type: Number
    },
    height: {
      type: [Number, String]
    },
    offsetY: {
      type: Number,
      default: 40
    },
    offsetX: {
      type: Number,
      default: 20
    },
    tableClassName: {
      type: String,
      default: 'tableStyle2'
    },
    headerCellClassName: {
      type: String,
      default: 'headerstyle2'
    },
    listQuery: {
      type: Object,
      default: () => {
        return {
          page_size: 50,
          page_no: 1
        }
      }
    },
    // 是否是可编辑型表格 开启后需要在动态表头进行配置
    // 用以区分编辑新增 查看
    isEditTypeTable: {
      type: Boolean,
      default: false
    },
    // 是否是表格嵌套表单
    isForm: {
      type: Boolean,
      default: false
    },
    // 动态表头配置：方法名
    fieldConfMethod: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      routeName: '',
      multipleSelection: [],
      isShowSummary: false, // 是否显示合计
      visible: true, //
      BASE_CDN_API: process.env.BASE_CDN_API,
      editArray: [], // 修改数据行汇总数组 需要支持切换分页也保留之前页数据
      visiblePopover: {
        // adjustment_reason: false
      }, // 监听popover显示问题
      batchEdit: {
        adjustment_reason_obj: {
          adjustment_reason: ''
        },
        upload_tax_amount_obj: {}
      }, // 批量修改的popover内的表单对象值
      refsList: {},
      tableChildren: [],
      fieldFnMethod: '',
      fieldList: [],
      isHaveFieldConfList: false, // 是否有通过fieldConf传入的field_list
      isHaveMethod: false, // 是否有通过fieldConfMethod传入
      isHaveConfFieldMethod: false
    }
  },
  computed: {
    newHeight: function(ctx) {
      const parts = ctx.height.match(/([0-9\.]+)(vh|vw)/)
      if (parts) {
        const q = Number(parts[1])
        const side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
        return side * (q / 100)
      } else {
        return ctx.height
      }
    },
    content() {
      return function(val) {
        return this.convertStringToObj(val)['HeaderInfo']
      }
    },
    // 方法返回字段内：是否配置需要合计列
    isMethodReturnsShowSummary() {
      const filterSumList = this.fieldList.filter(el => el.is_sum === 1)
      return filterSumList && filterSumList.length > 0
    },
    // 是否显示合计行
    isShowSummaryRow() {
      return this.isShowSummary || this.isMethodReturnsShowSummary
    },
  },
  watch: {
    list: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
      }
    },
    'fieldConf.field_list': {
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.isHaveFieldConfList = true
          this.getFieldData()
        }
      },
      immediate: true
    },
    fieldConfMethod: {
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.isHaveMethod = true
          this.getFieldData()
        }
      },
      immediate: true
    },
    'fieldConf.function_method': {
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.isHaveConfFieldMethod = true
          this.getFieldData()
        }
      },
      immediate: true
    }

  },
  created() {
    const str = '$data.detailList.test>=test.formValue.test1'
    const str1 = '$data.detailList.test>=22'
    const str2 = '$data.detailList.test>=formValue.test1'
    const str3 = 'data.detailList>=formValue.test1'
    const str4 = 'data.detailList===formValue.test1'
    const str5 = 'data.detailList!==formValue.test1'
    const str6 = 'data.detailList==formValue.test1'
    const str7 = 'data.detailList!=formValue.test1'
    const str8 = 'data.detailList!="123"'
    const str9 = '$this.list[i].upload_tax_amount>22'
    const regx = /(.+)([><!]={0,3})(.+)/g
  },
  mounted() {
    this.callMethod()
    this.bodyWrapper = this.$refs.table.bodyWrapper
    if (this.summaryMethod && !this.isEmptyFunction(this.summaryMethod)) {
      this.isShowSummary = true
    }
  },
  methods: {
    deepClone,
    parseTime,
    amountFormat,
    number_format,
    commonSumMethod,

    getList() {
      const data = {
        tableListQuery: this.listQuery
      }
      this.$emit('refresh', data)
    },
    typeOf(val) {
      return typeof val
    },
    openHeaderMenu(column, event) {
      this.$refs.headerMenu.openMenu(column, event)
    },
    handleDragent(newWidth, oldWidth, column, event) {
      this.$refs.headerMenu.handleDragent(newWidth, oldWidth, column, event)
    },
    /**
     * @description:
     * @param {*} row
     * @param {*} column
     * @param {*} event
     * @return {*}
     */
    openMenu(row, column, event) {
      this.$emit('rightMenuOperation', { row, column, event })
    },
    /**
     * @description: 多选
     * @param {*} val
     * @return {*}
     */
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.$emit('getSelectionData', this.multipleSelection)
    },
    /**
     * @description: 全选
     * @param {*}
     * @return {*}
     */
    handleSelectionChangeAll(val) {
      this.$emit('handleSelectionChangeAll', val)
    },
    /**
     * @description: 重新布局
     * @param {*}
     * @return {*}
     */
    doLayout() {
      this.$refs.table.doLayout()
    },
    /**
     * @description:  CheckBox 是否可以勾选
     * @param {*}
     * @return {*}
     */
    selectStatusInit(row, index) {
      if (
        this.isFucntion(this.selectInit) &&
        !this.isEmptyFunction(this.selectInit)
      ) {
        const bol = this.selectInit(row, index)
        row['_isDisabled'] = bol
        return bol
      } else {
        return true
      }
    },
    /**
     * @description: 接收父组件的注册事件
     * @param {*}
     * @return {*}
     */
    callMethod() {
      this.$on('tableclearSelection', res => {
        this.multipleSelection = []
        this.tableclearSelection()
      })
    },
    /**
     * @description: 清除列表选中
     * @param {*}
     * @return {*}
     */
    tableclearSelection() {
      this.multipleSelection = []
      this.$refs.table.clearSelection() // 删除后清空之前选择的数据
    },
    /**
     * @description: 是否是函数
     * @param {*}
     * @return {*}
     */
    isFucntion(func) {
      if (Object.prototype.toString.call(func) !== '[object Function]') {
        return false
      }
      return true
    },
    /**
     * @description: 是否是空函数
     * @param {*} func
     * @return {*}
     */
    isEmptyFunction(func) {
      let str = func.toString().replace(/\s+/g, '')
      str = str.match(/{.*}/g)[0]
      return str === '{}'
    },
    /**
     * @description: 鼠标移入事件
     * @param {*} row
     * @param {*} column
     * @param {*} cell
     * @return {*}
     */
    cellMouseEnter(row, column, cell) {
      this.$emit('cellMouseEnter', { row, column, cell })
    },
    /**
     * @description: 鼠标移出事件
     * @param {*} row
     * @param {*} column
     * @param {*} cell
     * @return {*}
     */
    cellMouseLeave(row, column, cell) {
      this.$emit('cellMouseLeave', { row, column, cell })
    },
    /**
     * @description: 当前行点亮
     * @param {*} data
     * @return {*}
     */
    setCurrentRow(data) {
      if (data && Object.prototype.toString.call(data) !== '[object Array]') {
        this.$nextTick(() => {
          this.list && this.list.length > 0 && this.$refs.table.setCurrentRow(data)
        })
      }
    },
    /**
     * @description: 将字符串转为json对象
     * @param {*}
     * @return {*}
     */
    convertStringToObj(str) {
      // 此处使用try catch 防止 json.parse 报错 导致程序出错
      try {
        return str && typeof str === 'string' ? eval('(' + str + ')') : {}
      } catch (error) {
        return {}
      }
    },
    /**
     * @description: 渲染链接
     * @param {*}
     * @return {*}
     */
    renderLink(baseurl, item, scopeRow) {
      const memoObj = this.convertStringToObj(item['memo']) || {}
      // 如何判定memo拓展字段中都是url需要的字段 暂时无法确定
      return item.field_type === 'innerLink' ? this.parseMemoToJoinUrl(memoObj, scopeRow) : this.parseMemoToOuterLink(memoObj, baseurl)
    },
    /**
     * @description: 转化memo拼接到需要跳转的url
     * @param {*} item 配置memo项json转的对象
     * @param {*} scopeRow 当前行数据
     * @return {*}
     */
    parseMemoToJoinUrl(item, scopeRow) {
      if (Object.prototype.toString.call(item) !== '[object Object]') return ''
      const { path, ..._router } = item
      const queryParams = []
      // 容错在配置memo 跳转路由没有加斜杠问题
      path && queryParams.push(`#${path.slice(0, 1) === '/' ? '' : '/'}${path}?`)
      for (const key in _router) {
        if (_router.hasOwnProperty(key)) {
          // id 特殊处理 idcode就是Id 是选择使用行数据中哪个字段来给查询详情时id赋值
          const val = _router[key]
          queryParams.push(`${key === 'idcode' ? 'id' : key}=${key === 'idcode' ? scopeRow[_router[key]] || scopeRow['id'] || '' : val || ''}`)
        }
      }
      queryParams.push(`t=${+new Date()}`)
      return queryParams.join('&')
    },
    /**
     * @description: 外部链接拼接
     * @param {*}
     * @return {*}
     */
    parseMemoToOuterLink(item, url) {
      if (Object.prototype.toString.call(item) !== '[object Object]') return ''
      const { iscdnTypeDownload } = item
      return iscdnTypeDownload ? this.BASE_CDN_API + url : url
    },
    /**
     * @description: 修改表单列表单行对应值
     * @param {*}
     * @return {*}
     */
    handleInput(val, key, item) {
      if (!this.isForm) return false
      Object.assign(item, { [key]: val })
    },
    /**
     * @description: 批量修改表单列表单行对应值
     * @param {*}
     * @return {*}
     */
    handleBatchInput(val, key, item) {
      if (!this.isForm) return false
      Object.assign(item, { [key]: val })
      this.$emit('getEditList', [...this.list.slice(0)])
    },
    /**
     * @description: 将表单元素转换成form-item需要解析的对象
     * @param {*} type 类型 input 等
     * @param {*} row 当前行数据
     * @param {*} key 当前列配置
     * @return {*}
     */
    typeToObject(type, row, item) {
      if (item) {
        const { field_code, field_data_value, isShow = true, disabled = false, rules } = item
        const memoCp = Object.assign({}, this.convertStringToObj(item['memo']))
        const temp = {}
        Object.assign(temp, {
          type,
          value: row && row[field_code] || null,
          rules: memoCp.tableRules || [],
          ...memoCp,
          isShow: this.tableInnerFormItemSDRCompile(memoCp, row)['isShow'],
          disabled: this.tableInnerFormItemSDRCompile(memoCp, row)['disabled']
        })

        /**
         * 如果有外部传入的 就用外部传入的
         * 验证规则
         */
        if (rules && rules.length > 0) {
          temp['rules'] = rules
        }
        /**
         * 如果有外部传入的 就用外部传入的
         * 是否显示
         */
        if (item && 'isShow' in item) {
          temp['isShow'] = isShow
        }
        /**
         * 如果有外部传入的 就用外部传入的
         * 元素禁用
         */
        if (item && 'disabled' in item) {
          temp['disabled'] = disabled
        }

        if (!(field_code in row)) {
          // 如果 新增的字段 不在当前这条数据返回结果中 意味着是新增的元素 item中不包含字段 就对当前表单元素新增key
          // temp['key'] = field_code
          row[field_code] = null
        }
        type === 'textarea' && (temp['subtype'] = 'textarea')
        type === 'text' && (temp['type'] = 'input')
        type === 'select' && (temp['dataSourceCode'] = field_data_value)
        return temp
      }
    },
    /**
     * @description:
     * 1、表格内部表单元素显示隐藏 禁用动态规则解析
     * 2、校验规则解析
     * @param {Object} memoCp memo 副本
     * @return {*}
     */
    tableInnerFormItemSDRCompile(memoCp, row) {
      const { disabledOption, showOption } = memoCp

      return {
        disabled: (disabledOption && Object.keys(disabledOption).length > 0) ? this.compileDisabledOption(disabledOption, 1, row) : false,
        isShow: (showOption && Object.keys(showOption).length > 0) ? this.compileDisabledOption(showOption, 2, row) : true
      }
    },
    /**
     * @description: 表格表单元素禁用规则解析
     * @param {string} option 禁用规则表达式
     * @param {Number} type 1 禁用规则 2 显示规则
     * @param {Object} row 当前行数据
     * @return {*}
     */
    compileDisabledOption(option, type, row) {
      // 配置项长度
      let len = option && option.length
      if (!option || len <= 0) {
        return type > 1
      }
      if (typeof option !== 'object') {
        console.error('禁用、显示规则类型不对，请传入正确的数组格式')
        return
      }

      // 初始化禁用状态为非禁用 false 显示状态为显示 true

      while (len > 0) {
        const { compareFormlua, op } = option[len - 1]
        const itemLen = compareFormlua && compareFormlua.length
        const initDisabledStatus = this.compileFormluaStatus(compareFormlua[0], type, row)
        const initShowStatus = this.compileFormluaStatus(compareFormlua[0], type, row)
        var status = type > 1 ? initShowStatus : initDisabledStatus

        if (itemLen > 1) {
          for (let i = 1; i < itemLen; i++) {
            switch (op) {
              case '||':
                status = status || this.compileFormluaStatus(compareFormlua[i], type, row)
                break
              case '&&':
                status = status && this.compileFormluaStatus(compareFormlua[i], type, row)
                break
              default:
                break
            }
          }
        }

        len--
      }

      /**
       * list[i] 当前行
       * formValue 主表表单里面的数据
       * data 表单实例里面的data数据
       */
      return status
    },

    // {
    // 'disabledOption': [
    //   {
    //     compareFormlua: ['$list[i].upload_tax_amount > 22'],
    //     op: '||'
    //   }
    // ]
    // }
    /**
     * @description: 取消对应的popover
     * @param {*}
     * @return {*}
     */
    closePopover(code) {
      this.$set(this.visiblePopover, code, false)
    },
    /**
     * @description: 批量修改
     * @param {*} formName 用来校验
     * @param {*} val
     * @return {*}
     */
    batchEditSave(formName, code) {
      this.$refs[formName][0].validate((valid) => {
        if (valid) {
          const list = this.list.slice(0)
          const len = list.length
          const dataObj = code + '_obj' // 用来获取数据
          const fieldVal = this['batchEdit'][dataObj] && this['batchEdit'][dataObj][code]

          for (let i = 0; i < len; i++) {
            this.$set(list[i], [code], fieldVal)
          }
          this.$set(this.visiblePopover, code, false)
        }
      })
    },
    /**
     * @description: 处理含有表单的列表 收集需要下拉框数据源 存储到sessionStorage
     * @param {*} conf
     * @return {*}
     */
    handleTableDataSource(conf) {
      const data_source_code_list = [this.fieldList && this.fieldList.map(item => item.field_data_value)].filter(item => item)
      let i = data_source_code_list.length - 1
      while (i >= 0) {
        const code = data_source_code_list[i]
        if (code) {
          const options = JSON.parse(sessionStorage.getItem(code))
          if (options && Object.keys(options).length > 0) {
            i--
            continue
          }
          EexcuteDataSource({ data_source_code: code }).then(response => {
            if (+response.data.res_status_code === 0) {
              const listData = response.data.res_content
              sessionStorage.setItem(code, JSON.stringify([...listData]))
            } else {
              this.$message.error(response.data.res_message)
            }
          })
        }
        i--
      }
    },
    /**
     * @description: 转换下拉框数据成文字
     * @param {*} val
     * @return {*}
     */
    getLabel(val) {
      const item = this.sexList.filter(item => item['value'] === val)[0]
      return item ? item.value : ''
    },

    /**
     * @description: 转换当前对应key可输入类型为字符串 查看状态
     * @param {*} row 数据
     * @param {*} item 自定义表头对象
     * @return {*}
     */
    convertString(row, item) {
      let str = ''
      const { field_value_type, field_code, field_input_type, field_data_value } = item
      switch (field_value_type) {
        case 'select':
          str = this.convertSelectOptionToLabel(field_data_value, row[field_code])
          break
        case 'text':
          str = row[field_code]
          break
        case 'textarea':
          str = row[field_code]
          break
        default:
          str = row[field_code]
          break
      }
      return str
    },
    /**
     * @description: 转换下拉选项框的值为文本
     * @param {*}
     * @return {*}
     */
    convertSelectOptionToLabel(selectKey, value) {
      if (value === undefined || value === null || value === '') {
        return ''
      }
      const list = JSON.parse(sessionStorage.getItem(selectKey))
      const filterList = list.filter(item => item.strValue == value) || []
      return (filterList.length > 0 && filterList[0]['strKey']) || value || ''
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    handleLinkChange(val, item, row, scope) {
      const events = this.convertStringToObj(item['memo']) && this.convertStringToObj(item['memo'])['events'] || {}
      const valueLink = this.convertStringToObj(item['memo']) && this.convertStringToObj(item['memo'])['valueLink'] || []
      const config = {
        type: item.field_value_type,
        key: item.field_code,
        placeholder: item.field_name,
        events: Object.assign({}, events),
        valueLink: valueLink.slice(0),
        isShow: true,
        disabled: false
      }
      this.$nextTick(() => {
        handleLinkChangeEvent({
          flag: 'table',
          val,
          item: config, // 当前元素配置
          formInstance: this.lowcodeFormInstance || {},
          formTableInstance: this || {},
          currentRowData: row || {}, //
          thisCp: this
        })
        this.handleInput(val, item.field_code, row)
        // 简陋版 不做对比diff 只要修改就进行保存
        if (!row['isExistItem']) {
          row['isExistItem'] = true
          this.editArray.push(row)
        }
        this.$emit('getEditList', [...this.editArray])
      })
      // todo 待做 升级版 比对原先数据 对比到字段 值修改后再保存
    },
    /**
     * @description: 解析规则
     * @param {string} formlua 判断规则公式
     * @param {Object} row 当前行数据
     * @return {*}
     */
    compileFormluaStatus(formlua, type, row) {
      if (!formlua) {
        return type > 1
      }
      if (formlua && typeof formlua !== 'string') {
        console.error('禁用规则类型不对，请传入正确的字符串格式')
        return
      }
      formlua = formlua.replace(/\s/g, '')
      const regx = /(.+)([><!]={0,3})(.+)/g
      const [wholeFormlua, frontFormlua, op, backFormlua] = regx.exec(formlua)
      //  不赋值 可能存在是数字或者是字符串的问题
      let frontValue
      let backValue
      if (frontFormlua.indexOf('[i]') > 0) {
        const isFrontNeedCompile = frontFormlua.lastIndexOf('.') >= 0
        const isBackNeedCompile = backFormlua.lastIndexOf('.') >= 0
        // $this.list[i] 是当前行 目前不考虑多层 应该到这里基本都只会有一层
        const frontlastDotIndex = frontFormlua.lastIndexOf('.') >= 0 ? frontFormlua.lastIndexOf('.') : frontFormlua
        const frontKey = frontFormlua.lastIndexOf('.') >= 0 ? frontFormlua.slice(frontlastDotIndex + 1) : frontFormlua

        const backlastDotIndex = backFormlua.lastIndexOf('.') >= 0 ? backFormlua.lastIndexOf('.') : backFormlua
        const backKey = backFormlua.lastIndexOf('.') >= 0 ? backFormlua.slice(backlastDotIndex + 1) : backFormlua
        frontValue = this.compileFrontFormluaValue({ row, frontKey, isNeedCompile: isFrontNeedCompile })
        backValue = this.compileBackFormluaValue({ row, backKey, isNeedCompile: isBackNeedCompile })
        return this.valueCompare({ type, op, frontValue, backValue })
      }
    },
    /**
     * @description: 前后值对比
     * @param {*} type 是否是行内对比
     * @param {*} op 对比操作符
     * @param {*} frontValue 前面解析值
     * @param {*} backValue 后面解析值
     * @return {*}
     */
    valueCompare(config) {
      const { type, op, frontValue, backValue } = config
      var isTrue = type > 1
      switch (op) {
        case '>':
        {
          isTrue = Number(frontValue || 0) > Number(backValue)
          break
        }
        case '>=':
        {
          isTrue = Number(frontValue || 0) >= Number(backValue)
          break
        }
        case '<':
        {
          isTrue = Number(frontValue || 0) < Number(backValue)
          break
        }
        case '<=':
        {
          isTrue = Number(frontValue || 0) <= Number(backValue)
          break
        }
        case '==':
        {
          isTrue = (frontValue || '') == (backValue)
          break
        }
        case '!=':
        {
          isTrue = (frontValue || '') != (backValue)
          break
        }
        case '===':
        {
          isTrue = (frontValue || '') === (backValue)
          break
        }
        case '!==':
        {
          isTrue = (frontValue || '') !== (backValue)
          break
        }
        default:
          break
      }

      return isTrue
    },
    /**
     * @description: 解析前公式值
     * @param {*}
     * @return {*}
     */
    compileFrontFormluaValue(config) {
      const { row, frontKey, isNeedCompile } = config
      return isNeedCompile ? row[frontKey] : frontKey
    },
    /**
     * @description: 解析后公式值
     * @param {*}
     * @return {*}
     */
    compileBackFormluaValue(config) {
      const { row, backKey, isNeedCompile } = config
      return isNeedCompile ? row[backKey] : backKey
    },
    /**
     * @description: 处理联动固定值赋值
     * @param linkKey {String} 关联key
     * @param curKey {String} 当前元素key
     * @param res {Object} 返回结果
     * @return {*}
     */
    handlelinkValueFix(config) {
      const _this = this.lowcodeFormInstance
      /**
       * 1、除字符串之外的数字
       * 2、字符串值
       * 3、字符串需要转真实的取值
       */
      const setLinkValue = {}
      setLinkValue['value'] = config // 真实的值
      setLinkValue['valueConfig'] = config // 值的配置
      let { valueConfig } = setLinkValue
      if (valueConfig.indexOf('.') < 0) {
        // 如果只有一个单独的key 默认将其挂载到data上去
        valueConfig = 'data.' + valueConfig
      }

      const fixedValue = this.getFixLinkValue(setLinkValue) // 解析后的值或者 传入的固定的值
    },
    /**
     * @description: 获取固定值模式下的值
     * @param value {String|Number} 表达式或者字符串 或者数字
     * @return {*}
     */
    getFixLinkValue(setLinkValue) {
      const { valueConfig, value } = setLinkValue
      if (typeof valueConfig === 'string') {
        const isFixValue = valueConfig.startsWith('$this.') // 判断是否是固定值 有$this的 都是需要特殊处理
        if (!isFixValue) {
          return value
        } else {
          const isTableInlineItem = valueConfig.startsWith('$this.list[i]') // 判断是否是表格行内部元素
          if (isTableInlineItem) {

          } else {
            const trueValue = eval(optionsChain(value.replace('$this.', '$this.lowcodeFormInstance.'))) // 从表单实例对象中取到对应的数据值
            return trueValue
          }
        }
      } else {
        return value
      }
    },
    // 获取动态表头数据
    getFieldData() {
      // 场景一：有通过fieldConf传入的field_list，直接赋值fieldList，无需调接口获取
      if (this.isHaveFieldConfList) {
        this.$set(this, 'fieldList', this.fieldConf.field_list)
        this.$set(this, 'fieldFnMethod', this.fieldConf.function_method)
      }
      // 场景二：传方法名fieldConfMethod，调接口获取field_list
      else if (this.isHaveMethod) {
        this.$set(this, 'fieldFnMethod', this.fieldConfMethod)
        if (!this.isHaveConfFieldMethod) this.getFieldList()
      }
      // 场景三：传fieldConf.function_method，调接口获取field_list
      else if (this.isHaveConfFieldMethod) {
        this.$set(this, 'fieldFnMethod', this.fieldConf.function_method)
        if (!this.isHaveMethod) this.getFieldList()
      }
    },
    /**
     * @description: 无field_list列表：通过动态表头方法名获取
     * @param {*} 方法名
     * @return {*} field_list列表
     */
    getFieldList() {
      GetUserListField({ function_method: this.fieldFnMethod }).then(response => {
        if (response.data.res_status_code === '0') {
          this.$set(this, 'fieldList', response.data.res_content.field_list)
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },

    // 表头被指合并
    getSummary({ columns, data }) {
      const list = this.commonSumMethod(columns, data, this.fieldList)
      const sumList = this.isMethodReturnsShowSummary ? [list] : []
      return sumList
    }
  }
}
</script>

<style lang="scss" scoped>
  .recombination_body .pagination-container {
    margin-top: 6px;
  }
</style>
<style lang="scss">
  .el-tooltip__popper{ max-width:500px}
</style>
